import React from "react";
import ChangePageTitle from "../components/change-title-page";
import Privacy_content from "../components/component-privacy";

function Privacy(){

    return(
        <>
            <ChangePageTitle pageTitle="حریم خصوصی | رستوران باغبان" />
            <Privacy_content />
        </>
    );

}

export default Privacy;